import SearchResult from "./SearchResult";

export default function SearchResults({
  searchResults,
  setSearchResults,
  searchError,
  setKeywords,
  keywords,
  searchLoading,
}) {
  let resultsDOM;
  if (!keywords) {
    resultsDOM = null;
  } else if (searchLoading) {
    resultsDOM = (
      <div className="p-4 text-foreground font-bold">Loading...</div>
    );
  } else if (searchError) {
    resultsDOM = (
      <div className="p-4 text-destructive u-text-symbolic-error">
        {searchError}
      </div>
    );
  } else if (
    !(searchResults && searchResults.length) &&
    searchResults !== null
  ) {
    resultsDOM = (
      <div className="p-4 text-foreground">
        <div>
          No results{" "}
          <span role="img" aria-label="grimace emoji">
            😬
          </span>
        </div>
        <div className="text-sm text-muted-foreground mt-2">
          Try the full property or unit name, or use property_code: to search by
          code.
        </div>
      </div>
    );
  } else if (searchResults && searchResults.length) {
    resultsDOM = searchResults.map((result, idx) => (
      <SearchResult
        key={idx}
        result={result}
        callbacks={{ setKeywords, setSearchResults }}
      />
    ));
  }

  return (
    <ul className="bg-background rounded-md dark:border dark:border-border overflow-hidden">
      {resultsDOM}
    </ul>
  );
}
